import Http from './http';
import { savedSearchCacheTTL } from 'Config';
import store from 'store';

class SavedSearchService {
    constructor() {
        this.savedSearches = null;
        // var intervalID = setInterval(()=>{
        //     this.resetCache()
        // }, savedSearchCacheTTL);
    }

    resetCache(){
        if (!this.savedSearches) return;
        store.set('savedSearches', false)
        this.savedSearches = null;
        this.getSavedSearches()
    }

    getSavedSearches() {
        return new Promise((resolve, reject) => {
            if (store.get('savedSearches', false)){
                this.savedSearches = store.get('savedSearches');
            }
            if (this.savedSearches) resolve(this.savedSearches);
            else {
                Http.get('/saved-search/').then(resp => {
                    this.savedSearches = resp.data;
                    store.set('savedSearches', this.savedSearches)
                    resolve(resp.data);
                });
            }
        })
    }
}

export default new SavedSearchService();


// WEBPACK FOOTER //
// ./src/services/Cache/micro-services/savedSearch.js